"use client";

import { LazyMotion, MotionConfig } from "framer-motion";

const loadFeatures = () => import("@/lib/motion-features").then((mod) => mod.default);

/**
 * framer-motion nur als schlanker `m`-Baustein; die Animations-Features
 * (~25 KB) kommen asynchron nach der Hydration (LazyMotion, strict:
 * `motion.*` ist verboten). `reducedMotion="user"` respektiert
 * prefers-reduced-motion in allen Animationen.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
}
